import Limit from '../Limit'
import PropTypes from 'prop-types'

function Coverages({ coverages }) {
  if (!coverages) return false

  return (
    <div className="flex flex-col space-y-2">
      {Object.keys(coverages || {}).map((coverageSlug, i) => (
        <div key={`coverage-${i}`}>
          <div className="mb-2 font-semibold capitalize">
            {coverageSlug.replace(/_/g, ' ')}
          </div>
          {/* Premium */}
          {coverages[coverageSlug]?.premium && (
            <div className="flex justify-between space-x-4 space-y-1 pl-4 text-sm text-gray-600">
              <div>Premium</div>
              <Limit limit={coverages[coverageSlug]['premium']} />
            </div>
          )}

          {/* Limits */}
          {Object.keys(coverages[coverageSlug]?.limits || {}).map(
            (limitName, j) => (
              <div
                key={`coverage-sub-limit-${j}`}
                className="flex justify-between space-x-4 space-y-1 pl-4 text-sm capitalize text-gray-600"
              >
                <div className="capitalize">{limitName.replace(/_/g, ' ')}</div>
                <Limit limit={coverages[coverageSlug]['limits'][limitName]} />
              </div>
            )
          )}

          {/* Deductibles */}
          {coverages[coverageSlug]?.deductible && (
            <div className="flex justify-between space-x-4 space-y-1 pl-4 text-sm text-gray-600">
              <div className="capitalize">Deductible</div>
              <Limit limit={coverages[coverageSlug]['deductible']} />
            </div>
          )}
        </div>
      ))}
    </div>
  );
}

Coverages.propTypes = {
  coverages: PropTypes.object,
}

export default Coverages
